// extracted by mini-css-extract-plugin
export default {"inputButton":"CustomInput_inputButton__Tz01M","inputActive":"CustomInput_inputActive__m8STs","placeholder":"CustomInput_placeholder__DuX5M"};